import axios from 'axios';

let showForbiddenErrorCallback = null;

// Set the callback function from the context
export const setForbiddenErrorCallback = (callback) => {
  showForbiddenErrorCallback = callback;
};

// Create axios instance
const axiosInstance = axios.create({
  baseURL: 'https://dailycard.co/api', // ضع هنا الـ base URL بتاع الـ API
});

// Request interceptor to add token
axiosInstance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('accessToken');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor to handle 403 errors
axiosInstance.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error.response && error.response.status === 403) {
      const message = error.response.data?.message || 'ليس لديك صلاحية للوصول إلى هذه الصفحة';
      
      if (showForbiddenErrorCallback) {
        showForbiddenErrorCallback(message);
      }
    }
    
    return Promise.reject(error);
  }
);

export default axiosInstance;